import { IGif, IImage, IImages } from '@giphy/js-types'
import { getBestRendition, getGifHeight } from '@giphy/js-util'
import fromEntries from 'fromentries'

const defaultMaxMB = 20

const getGifDisplayUrl = (gif: IGif, width: number) => {
    const height = getGifHeight(gif, width)
    const maxSize = window.maxGifMBForSharing || defaultMaxMB
    const predicate = ([, rendition]: [string, IImage]) =>
        rendition.size ? parseInt(rendition.size) / 1e6 < maxSize : false
    const filtered = fromEntries(Object.entries(gif.images).filter(predicate)) as IImages
    const rendition = getBestRendition(filtered, width, height)
    const url = (gif.images[rendition.renditionName] as IImage).url
    return url
}

export default getGifDisplayUrl
